import { render, staticRenderFns } from "./EdicaoNascimento.vue?vue&type=template&id=1402b606&"
import script from "./EdicaoNascimento.vue?vue&type=script&lang=js&"
export * from "./EdicaoNascimento.vue?vue&type=script&lang=js&"
import style0 from "./EdicaoNascimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports